// import React, { useState, useEffect, useMemo, useRef } from 'react';
// import { useSelector, useDispatch } from 'react-redux';
// import { useNavigate } from 'react-router-dom';
// import { Plus, X, ChevronDown, User, Search, Loader2, Info, AlertCircle, CheckCircle } from 'lucide-react';
// import { getLeaveTypeByUser } from '../../action/LeaveType';
// import IsoDateInput from '../../components/common/Isodateinput';
// import { addLeaveAdjustment, fetchAllAdjustments } from '../../action/leaveadjuestments';

// const getAuth = () => localStorage.getItem('auth-key') || '';

// const fmt = (v) => (!v || v === 'null') ? '' : String(v).trim();

// const INP = "w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-400 bg-gray-50 focus:bg-white transition-colors";
// const SEL = INP + " appearance-none";
// const LBL = "block text-[11px] font-semibold text-gray-600 mb-1 uppercase tracking-wide";

// // ─── Table column config — edit widths/alignment here, per column ────────────
// const COLUMNS = [
//   { key: 'employee', label: 'Employee', width: '100px', headerAlign: 'text-left', cellAlign: 'text-left' },
//   { key: 'leaveType', label: 'Leave Type', width: '130px', headerAlign: 'text-center', cellAlign: 'text-center' },
//   { key: 'date', label: 'Date', width: '120px', headerAlign: 'text-left', cellAlign: 'text-left' },
//   { key: 'inTime', label: 'In Time', width: '100px', headerAlign: 'text-center', cellAlign: 'text-center' },
//   { key: 'outTime', label: 'Out Time', width: '100px', headerAlign: 'text-center', cellAlign: 'text-center' },
//   { key: 'reason', label: 'Reason', width: '260px', headerAlign: 'text-left', cellAlign: 'text-left' },
//   { key: 'status', label: 'Status', width: '130px', headerAlign: 'text-center', cellAlign: 'text-center' },
// ];

// // ─── Employee search dropdown ─────────────────────────────────────────────────
// function EmpSearch({ value, onChange, employees, placeholder = 'Search employee...' }) {
//   const [q, setQ] = useState('');
//   const [open, setOpen] = useState(false);
//   const ref = useRef();
//   const filtered = useMemo(() => {
//     if (!q) return employees;
//     const lq = q.toLowerCase();
//     return employees.filter(e =>
//       fmt(e.p_ced_service_no).toLowerCase().includes(lq) ||
//       `${fmt(e.p_first_name)} ${fmt(e.p_last_name)}`
//         .toLowerCase()
//         .includes(lq) ||
//       fmt(e.p_report_name).toLowerCase().includes(lq)
//     );
//   }, [employees, q]);

//   const selected = employees.find(e => fmt(e.p_ced_service_no) === value);
//   const displayName = selected
//     ? `${fmt(selected.p_ced_service_no)} — ${fmt(selected.p_report_name) || `${fmt(selected.p_first_name)} ${fmt(selected.p_last_name)}`}`
//     : '';
//   useEffect(() => {
//     const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
//     document.addEventListener('mousedown', handler);
//     return () => document.removeEventListener('mousedown', handler);
//   }, []);
//   return (
//     <div ref={ref} className="relative">
//       <div className={`${INP} flex items-center gap-2 cursor-pointer`} onClick={() => setOpen(v => !v)}>
//         <User size={13} className="text-gray-400 shrink-0" />
//         <span className={`flex-1 text-sm truncate ${value ? 'text-gray-800' : 'text-gray-400'}`}>
//           {value ? displayName : placeholder}
//         </span>
//         <ChevronDown size={12} className={`text-gray-400 transition-transform ${open ? 'rotate-180' : ''}`} />
//       </div>
//       {open && (
//         <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-200 rounded-xl shadow-xl z-50">
//           <div className="p-2 border-b border-gray-100">
//             <div className="relative">
//               <Search size={12} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400" />
//               <input autoFocus value={q} onChange={e => setQ(e.target.value)}
//                 placeholder="Name or service no..."
//                 className="w-full pl-7 pr-3 py-1.5 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-1 focus:ring-primary-300" />
//             </div>
//           </div>
//           <div className="max-h-52 overflow-y-auto py-1">
//             {filtered.length === 0
//               ? <p className="text-center text-[12px] text-gray-400 py-3">No results</p>
//               : filtered.map(e => {
//                 const sno = fmt(e.p_ced_service_no);
//                 const name = fmt(e.p_report_name) || `${fmt(e.p_first_name)} ${fmt(e.p_last_name)}`.trim();
//                 return (
//                   <button key={sno} onClick={() => { onChange(sno, e); setOpen(false); setQ(''); }}
//                     className={`w-full flex items-center gap-2.5 px-3 py-2 hover:bg-primary-50 transition-colors text-left
//                         ${value === sno ? 'bg-primary-50 text-primary-700' : ''}`}>
//                     <span className="text-[11px] font-mono text-gray-400 w-16 shrink-0">{sno}</span>
//                     <span className="text-[12px] text-gray-800 truncate">{name}</span>
//                   </button>
//                 );
//               })}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// // ─── Success Modal ─────────────────────────────────────────────────
// function SuccessModal({ isOpen, message, onClose }) {
//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
//       <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 p-6 transform transition-all">
//         <div className="flex flex-col items-center text-center">
//           <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mb-4">
//             <CheckCircle size={32} className="text-emerald-600" />
//           </div>
//           <h3 className="text-xl font-bold text-gray-900 mb-2">Success!</h3>
//           <p className="text-gray-600 text-sm mb-6">{message || 'Leave adjustment added successfully!'}</p>
//           <button
//             onClick={onClose}
//             className="px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-lg transition-colors"
//           >
//             OK
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// // ─── Error Modal ─────────────────────────────────────────────────
// function ErrorModal({ isOpen, message, onClose }) {
//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
//       <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 p-6 transform transition-all">
//         <div className="flex flex-col items-center text-center">
//           <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
//             <AlertCircle size={32} className="text-red-600" />
//           </div>
//           <h3 className="text-xl font-bold text-gray-900 mb-2">Error</h3>
//           <p className="text-gray-600 text-sm mb-6">{message || 'Failed to add leave adjustment'}</p>
//           <button
//             onClick={onClose}
//             className="px-6 py-2.5 bg-red-500 hover:bg-red-600 text-white font-medium rounded-lg transition-colors"
//           >
//             Close
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default function LeaveAdjustments() {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const { employees } = useSelector(s => s.employees);
//   const authUser = useSelector(s => s.auth.user);
//   const userId = authUser?.raw?.ADU_EmployeeId || authUser?.serviceNo || '';

//   const employeeOptions = useMemo(() => {
//     return (employees || []).map(emp => ({
//       ...emp,
//       p_ced_service_no: emp.p_ced_service_no || emp.HED_SERVICE_NO || emp.HED_CED_SERVICE_NO || '',
//       p_first_name: emp.p_first_name || emp.HED_FIRST_NAME || '',
//       p_last_name: emp.p_last_name || emp.HED_LAST_NAME || '',
//       p_report_name: emp.p_report_name || emp.HED_REPORT_NAME || '',
//       p_barcode: emp.p_barcode || emp.HED_SERVICE_NO || '',
//       p_location_code: emp.p_location_code || emp.HED_LOCATION_ID || '',
//       p_department_code: emp.p_department_code || emp.HDD_DEPARTMENT_CODE || '',
//       p_division_code: emp.p_division_code || emp.HED_GROUP || '',
//     }));
//   }, [employees]);

//   const [adjustments, setAdjustments] = useState([]);
//   const [modalOpen, setModalOpen] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [loadingLeaveTypes, setLoadingLeaveTypes] = useState(false);
//   const [loadingAdjustments, setLoadingAdjustments] = useState(false);
//   const [leaveTypes, setLeaveTypes] = useState([]);
//   const [leaveTypeInfo, setLeaveTypeInfo] = useState('');

//   // Modal states
//   const [showSuccessModal, setShowSuccessModal] = useState(false);
//   const [showErrorModal, setShowErrorModal] = useState(false);
//   const [modalMessage, setModalMessage] = useState('');

//   const today = new Date().toISOString().split('T')[0];

//   const [form, setForm] = useState({
//     employeeId: '',
//     serviceNo: '',
//     attendanceDate: today,
//     inTime: '09:00:00',
//     outTime: '18:00:00',
//     adjType: '',
//     adjReason: '',
//     adjStatus: 'P',
//     docId: '',
//   });

//   const set = (k, v) => setForm(p => ({ ...p, [k]: v }));

//   // ─── Fetch all adjustments on component mount ─────────────────────────
//   useEffect(() => {
//     fetchAdjustments();
//   }, []);

//   const fetchAdjustments = async () => {
//     console.log("[COMPONENT] fetchAdjustments called");
//     setLoadingAdjustments(true);
//     try {
//       console.log("[COMPONENT] Dispatching fetchAllAdjustments...");
//       const result = await dispatch(fetchAllAdjustments());
//       console.log("[COMPONENT] fetchAllAdjustments result:", result);

//       // The result is now an array of 3 responses: [approved, complete, pending]
//       if (result && Array.isArray(result) && result.length > 0) {
//         console.log("[COMPONENT] Result is an array with length:", result.length);

//         // Combine all ResultSets from each response
//         let allAdjustmentsData = [];

//         result.forEach((response, index) => {
//           console.log(`[COMPONENT] Processing response ${index}:`, response);

//           if (response && response.ResultSet && Array.isArray(response.ResultSet)) {
//             console.log(`[COMPONENT] Response ${index} has ResultSet with ${response.ResultSet.length} items`);
//             allAdjustmentsData = [...allAdjustmentsData, ...response.ResultSet];
//           } else if (response && response.data && response.data.ResultSet && Array.isArray(response.data.ResultSet)) {
//             console.log(`[COMPONENT] Response ${index} has data.ResultSet with ${response.data.ResultSet.length} items`);
//             allAdjustmentsData = [...allAdjustmentsData, ...response.data.ResultSet];
//           } else if (response && Array.isArray(response)) {
//             console.log(`[COMPONENT] Response ${index} is an array with ${response.length} items`);
//             allAdjustmentsData = [...allAdjustmentsData, ...response];
//           }
//         });

//         console.log("[COMPONENT] Combined all adjustments data:", allAdjustmentsData);
//         console.log("[COMPONENT] Total adjustments count:", allAdjustmentsData.length);

//         if (allAdjustmentsData.length > 0) {
//           // Remove duplicates based on HAA_ADJUSTMENTS_ID
//           const uniqueAdjustments = [];
//           const seenIds = new Set();

//           allAdjustmentsData.forEach(item => {
//             const id = item.HAA_ADJUSTMENTS_ID || item.id;
//             if (id && !seenIds.has(id)) {
//               seenIds.add(id);
//               uniqueAdjustments.push(item);
//             } else if (!id) {
//               // If no ID, keep it (but this shouldn't happen)
//               uniqueAdjustments.push(item);
//             }
//           });

//           console.log("[COMPONENT] Unique adjustments count:", uniqueAdjustments.length);

//           // Map the data to your table format
//           const mappedAdjustments = uniqueAdjustments.map((item) => {
//             // Format date from "8/18/2026 12:00:00 AM" to display format
//             const formatDateForDisplay = (dateStr) => {
//               if (!dateStr) return '';
//               try {
//                 const date = new Date(dateStr);
//                 if (isNaN(date.getTime())) return dateStr;
//                 const p = (n) => String(n).padStart(2, '0');
//                 return `${date.getFullYear()}-${p(date.getMonth() + 1)}-${p(date.getDate())}`;
//               } catch {
//                 return dateStr;
//               }
//             };

//             // Extract time from "1/1/1900 9:00:00 AM" to "09:00:00"
//             const extractTime = (dateTimeStr) => {
//               if (!dateTimeStr) return '';
//               try {
//                 const date = new Date(dateTimeStr);
//                 if (isNaN(date.getTime())) return dateTimeStr;
//                 return date.toTimeString().split(' ')[0];
//               } catch {
//                 return dateTimeStr;
//               }
//             };

//             return {
//               id: item.HAA_ADJUSTMENTS_ID || item.id || Date.now(),
//               employeeId: item.HAA_EMPLOYEE_ID || item.employeeId || '',
//               serviceNo: item.HAA_EMPLOYEE_ID || item.serviceNo || '',
//               employeeName: item.HAA_EMPLOYEE_NAME || item.employeeName || '',
//               leaveType: item.HAA_ADJ_TYPE || item.leaveType || '',
//               date: item.HAA_ATTENDANCE_DATE || item.attendanceDate || '',
//               dateDisplay: formatDateForDisplay(item.HAA_ATTENDANCE_DATE || item.attendanceDate || ''),
//               inTime: extractTime(item.HAA_IN_TIME || item.inTime || ''),
//               outTime: extractTime(item.HAA_OUT_TIME || item.outTime || ''),
//               reason: item.HAA_ADJ_REASON || item.reason || '',
//               status: item.HAA_ADJ_STATUS || item.status || 'P',
//               approvedBy: item.HAA_ADJ_APPROVED_BY || '',
//               approvedDate: item.HAA_ADJ_APPROVED_DATE || '',
//               docId: item.HAA_DOC_ID || '',
//               createdBy: item.HAA_CREATED_BY || '',
//               createdDate: item.HAA_CREATED_DATE || '',
//               updatedBy: item.HAA_UPDATED_BY || '',
//               updatedDate: item.HAA_UPDATED_DATE || '',
//             };
//           });

//           console.log("[COMPONENT] Mapped adjustments:", mappedAdjustments);
//           setAdjustments(mappedAdjustments);
//         } else {
//           console.log("[COMPONENT] No adjustments data found");
//           setAdjustments([]);
//         }
//       } else if (result && result.ResultSet && Array.isArray(result.ResultSet)) {
//         // Handle case where result is a single response (backward compatibility)
//         console.log("[COMPONENT] Result is a single response with ResultSet");
//         const adjustmentsData = result.ResultSet;
//         const mappedAdjustments = adjustmentsData.map((item) => {
//           const formatDateForDisplay = (dateStr) => {
//             if (!dateStr) return '';
//             try {
//               const date = new Date(dateStr);
//               if (isNaN(date.getTime())) return dateStr;
//               const p = (n) => String(n).padStart(2, '0');
//               return `${date.getFullYear()}-${p(date.getMonth() + 1)}-${p(date.getDate())}`;
//             } catch {
//               return dateStr;
//             }
//           };

//           const extractTime = (dateTimeStr) => {
//             if (!dateTimeStr) return '';
//             try {
//               const date = new Date(dateTimeStr);
//               if (isNaN(date.getTime())) return dateTimeStr;
//               return date.toTimeString().split(' ')[0];
//             } catch {
//               return dateTimeStr;
//             }
//           };

//           return {
//             id: item.HAA_ADJUSTMENTS_ID || item.id || Date.now(),
//             employeeId: item.HAA_EMPLOYEE_ID || item.employeeId || '',
//             serviceNo: item.HAA_EMPLOYEE_ID || item.serviceNo || '',
//             employeeName: item.HAA_EMPLOYEE_NAME || item.employeeName || '',
//             leaveType: item.HAA_ADJ_TYPE || item.leaveType || '',
//             date: item.HAA_ATTENDANCE_DATE || item.attendanceDate || '',
//             dateDisplay: formatDateForDisplay(item.HAA_ATTENDANCE_DATE || item.attendanceDate || ''),
//             inTime: extractTime(item.HAA_IN_TIME || item.inTime || ''),
//             outTime: extractTime(item.HAA_OUT_TIME || item.outTime || ''),
//             reason: item.HAA_ADJ_REASON || item.reason || '',
//             status: item.HAA_ADJ_STATUS || item.status || 'P',
//             approvedBy: item.HAA_ADJ_APPROVED_BY || '',
//             approvedDate: item.HAA_ADJ_APPROVED_DATE || '',
//             docId: item.HAA_DOC_ID || '',
//             createdBy: item.HAA_CREATED_BY || '',
//             createdDate: item.HAA_CREATED_DATE || '',
//             updatedBy: item.HAA_UPDATED_BY || '',
//             updatedDate: item.HAA_UPDATED_DATE || '',
//           };
//         });
//         setAdjustments(mappedAdjustments);
//       } else {
//         console.log("[COMPONENT] No result or unexpected format, setting empty array");
//         setAdjustments([]);
//       }
//     } catch (error) {
//       console.error("[COMPONENT] Error fetching adjustments:", error);
//       console.error("[COMPONENT] Error details:", {
//         name: error.name,
//         message: error.message,
//         stack: error.stack
//       });
//       setAdjustments([]);
//     } finally {
//       console.log("[COMPONENT] fetchAdjustments completed, setting loading to false");
//       setLoadingAdjustments(false);
//     }
//   };

//   // ─── Fetch leave types when employee is selected ─────────────────────────
//   useEffect(() => {
//     const fetchLeaveTypes = async () => {
//       const serviceNo = form.serviceNo;

//       if (!serviceNo) {
//         setLeaveTypes([]);
//         setLeaveTypeInfo('Please select an employee first to view available leave types');
//         return;
//       }

//       setLoadingLeaveTypes(true);
//       setLeaveTypeInfo('Loading leave types...');

//       try {
//         const result = await getLeaveTypeByUser(serviceNo);

//         if (result.success && result.data) {
//           let leaveTypesArray = [];

//           if (Array.isArray(result.data)) {
//             leaveTypesArray = result.data;
//           } else if (result.data.ResultSet && Array.isArray(result.data.ResultSet)) {
//             leaveTypesArray = result.data.ResultSet;
//           } else if (result.data.resultSet && Array.isArray(result.data.resultSet)) {
//             leaveTypesArray = result.data.resultSet;
//           } else if (result.data.data && Array.isArray(result.data.data)) {
//             leaveTypesArray = result.data.data;
//           } else if (typeof result.data === 'object') {
//             for (const key of Object.keys(result.data)) {
//               if (Array.isArray(result.data[key]) && result.data[key].length > 0) {
//                 leaveTypesArray = result.data[key];
//                 break;
//               }
//             }
//           }

//           if (leaveTypesArray.length === 0) {
//             setLeaveTypes([]);
//             setLeaveTypeInfo('No leave types available for this employee');
//             return;
//           }

//           const mappedTypes = leaveTypesArray.map(item => {
//             if (typeof item === 'string' || typeof item === 'number') {
//               return {
//                 code: String(item),
//                 label: String(item),
//                 calculationMethod: String(item)
//               };
//             }

//             const code = item.HLP_LEAVE_TYPE_ID ||
//                         item.leaveTypeId ||
//                         item.LeaveTypeId ||
//                         item.id ||
//                         item.ID ||
//                         '';

//             const calcMethod = item.HLP_CALCULATION_METHOD ||
//                               item.calculationMethod ||
//                               item.CalculationMethod ||
//                               '';

//             let label = '';
//             if (calcMethod) {
//               label = calcMethod.replace(/_/g, ' ').toLowerCase()
//                 .replace(/\b\w/g, char => char.toUpperCase());
//             } else if (item.label) {
//               label = item.label;
//             } else if (item.name) {
//               label = item.name;
//             } else {
//               label = `Leave Type ${code}`;
//             }

//             return {
//               code: String(code).trim(),
//               label: label,
//               calculationMethod: calcMethod,
//               raw: item
//             };
//           });

//           const validTypes = mappedTypes.filter(type => type.code);

//           if (validTypes.length > 0) {
//             setLeaveTypes(validTypes);
//             setLeaveTypeInfo(`${validTypes.length} leave type(s) available for this employee`);

//             if (!form.adjType) {
//               set('adjType', validTypes[0].code);
//             }
//           } else {
//             setLeaveTypes([]);
//             setLeaveTypeInfo('No valid leave types found for this employee');
//           }
//         } else {
//           setLeaveTypes([]);
//           setLeaveTypeInfo(result.message || 'Failed to load leave types');
//         }
//       } catch (error) {
//         console.error('Error fetching leave types:', error);
//         setLeaveTypes([]);
//         setLeaveTypeInfo('Error loading leave types. Please try again.');
//       } finally {
//         setLoadingLeaveTypes(false);
//       }
//     };

//     fetchLeaveTypes();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [form.serviceNo]);

//   // ─── Employee selection handler ──────────────────────────────────────────
//   const onEmpSelect = (sno, emp) => {
//     setForm(p => ({
//       ...p,
//       employeeId: sno,
//       serviceNo: sno,
//     }));
//   };

//   function openModal() {
//     setModalOpen(true);
//   }

//   function closeModal() {
//     setModalOpen(false);
//     setForm({
//       employeeId: '',
//       serviceNo: '',
//       attendanceDate: today,
//       inTime: '09:00:00',
//       outTime: '18:00:00',
//       adjType: '',
//       adjReason: '',
//       adjStatus: 'P',
//       docId: '',
//     });
//     setLeaveTypes([]);
//     setLeaveTypeInfo('');
//   }

//   // ─── Handle modal close and refresh ────────────────────────────────────
//   const handleSuccessModalClose = () => {
//     setShowSuccessModal(false);
//     setLoading(false);
//     // Refresh the adjustments list
//     fetchAdjustments();
//     // Close the adjustment form and reset everything
//     closeModal();
//   };

//   const handleErrorModalClose = () => {
//     setShowErrorModal(false);
//     setLoading(false);
//   };

//   // ─── Handle submit ──────────────────────────────────────────────────────
//   const handleSave = async () => {
//     if (!form.serviceNo) {
//       setModalMessage('Employee required');
//       setShowErrorModal(true);
//       return;
//     }
//     if (!form.adjType) {
//       setModalMessage('Leave type required');
//       setShowErrorModal(true);
//       return;
//     }
//     if (!form.attendanceDate) {
//       setModalMessage('Date required');
//       setShowErrorModal(true);
//       return;
//     }
//     if (!form.adjReason) {
//       setModalMessage('Reason required');
//       setShowErrorModal(true);
//       return;
//     }
//     if (!userId) {
//       setModalMessage('Unable to determine logged-in user. Please log in again.');
//       setShowErrorModal(true);
//       return;
//     }

//     setLoading(true);
//     closeModal()
//     setShowSuccessModal(false);
//     setShowErrorModal(false);

//     try {
//       const result = await addLeaveAdjustment(
//         form.serviceNo,
//         form.attendanceDate,
//         form.inTime,
//         form.outTime,
//         form.adjType,
//         form.adjReason,
//         form.adjStatus,
//         form.docId,
//         userId
//       );

//       console.log('Leave adjustment result:', result);

//       let isSuccess = false;
//       let responseMessage = '';

//       if (result && result.success) {
//         isSuccess = true;
//         responseMessage = result.message || 'Leave adjustment added successfully!';
//       } else if (typeof result === 'string') {
//         responseMessage = result;
//         isSuccess = result.toLowerCase().includes('success') ||
//                    result.toLowerCase().includes('successfully');
//       } else if (result && typeof result === 'object') {
//         if (result.StatusCode === 200) {
//           isSuccess = true;
//           responseMessage = result.Result || 'Leave adjustment added successfully!';
//         } else if (result.success === true) {
//           isSuccess = true;
//           responseMessage = result.message || 'Leave adjustment added successfully!';
//         } else if (result.status === 'success' || result.status === 'Success') {
//           isSuccess = true;
//           responseMessage = result.message || 'Leave adjustment added successfully!';
//         } else {
//           isSuccess = false;
//           responseMessage = result.message || result.Result || 'Failed to add leave adjustment';
//         }
//       } else if (result) {
//         isSuccess = true;
//         responseMessage = 'Leave adjustment added successfully!';
//       } else {
//         isSuccess = false;
//         responseMessage = 'Failed to add leave adjustment';
//       }

//       setLoading(false);

//       if (isSuccess) {
//         setModalMessage(responseMessage);
//         setShowSuccessModal(true);
//       } else {
//         setModalMessage(responseMessage);
//         setShowErrorModal(true);
//       }

//     } catch (e) {
//       console.error('Error adding leave adjustment:', e);
//       setLoading(false);
//       const errorMsg = typeof e === 'string' ? e : (e?.message || 'Failed to add leave adjustment');

//       if (errorMsg.toLowerCase().includes('success') ||
//           errorMsg.toLowerCase().includes('successfully')) {
//         setModalMessage(errorMsg);
//         setShowSuccessModal(true);
//       } else {
//         setModalMessage(errorMsg);
//         setShowErrorModal(true);
//       }
//     }
//   };

//   const formatDate = (dateStr) => {
//     if (!dateStr) return '—';
//     try {
//       const date = new Date(dateStr);
//       if (isNaN(date.getTime())) return dateStr;
//       const p = (n) => String(n).padStart(2, '0');
//       return `${date.getFullYear()}-${p(date.getMonth() + 1)}-${p(date.getDate())}`;
//     } catch {
//       return dateStr;
//     }
//   };

//   const formatTime = (timeStr) => {
//     if (!timeStr) return '—';
//     try {
//       const date = new Date(timeStr);
//       if (isNaN(date.getTime())) return timeStr;
//       return date.toTimeString().split(' ')[0];
//     } catch {
//       return timeStr;
//     }
//   };

//   const getStatusLabel = (status) => {
//     if (!status) return 'Pending';
//     const upperStatus = status.toUpperCase();
//     switch (upperStatus) {
//       case 'P':
//         return 'Pending';
//       case 'A':
//         return 'Approved';
//       case 'R':
//         return 'Rejected';
//       default:
//         return status;
//     }
//   };

//   return (
//     <div className="min-h-full bg-gray-50">
//       {/* ── Success Modal ─────────────────────────────────────── */}
//       <SuccessModal
//         isOpen={showSuccessModal}
//         message={modalMessage}
//         onClose={handleSuccessModalClose}
//       />

//       {/* ── Error Modal ───────────────────────────────────────── */}
//       <ErrorModal
//         isOpen={showErrorModal}
//         message={modalMessage}
//         onClose={handleErrorModalClose}
//       />

//       {/* ── Loading Overlay ───────────────────────────────────── */}
//       {loading && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
//           <div className="bg-white rounded-2xl shadow-2xl p-8 flex flex-col items-center">
//             <Loader2 size={48} className="text-primary-500 animate-spin mb-4" />
//             <p className="text-gray-700 font-medium">Adding leave adjustment...</p>
//             <p className="text-gray-400 text-sm mt-1">Please wait</p>
//           </div>
//         </div>
//       )}

//       {/* ── Page header ─────────────────────────────────────────── */}
//       <div className="mb-6 flex items-start justify-between gap-4">
//         <div>
//           <h1 className="text-2xl font-bold text-gray-900">
//             Leave Adjustments
//           </h1>

//           <p className="mt-1 text-sm text-gray-500">
//             Manage and review employee leave adjustments.
//           </p>
//         </div>

//         <button
//           onClick={openModal}
//           className="flex shrink-0 items-center gap-2 rounded-lg bg-primary-600 px-4 py-2.5 text-sm font-medium text-white hover:bg-primary-700"
//         >
//           Add Adjustment
//         </button>
//       </div>

//       {/* ── Table card ──────────────────────────────────────────── */}
//       <div className="rounded-xl border border-gray-200 bg-white shadow-sm overflow-hidden">
//         <div className="px-5 py-3.5 border-b border-gray-200 flex items-center justify-between">
//           <h3 className="text-sm font-semibold text-gray-900">Adjustment Records</h3>
//           <span className="text-xs text-gray-500">
//             {loadingAdjustments ? '' : `${adjustments.length} record${adjustments.length === 1 ? '' : 's'}`}
//           </span>
//         </div>
//         <div className="overflow-x-auto">
//           {/* OLD table markup (kept for reference, commented out):
//           <table className="w-full min-w-[920px] border-collapse text-[13px]">
//             <thead>
//               <tr className="bg-white border-b border-gray-200">
//                 {['Employee', 'Leave Type', 'Date', 'In Time', 'Out Time', 'Reason', 'Status'].map((h) => (
//                   <th
//                     key={h}
//                     className="whitespace-nowrap px-4 py-3 text-left text-[12px] font-semibold text-gray-500"
//                   >
//                     {h}
//                   </th>
//                 ))}
//               </tr>
//             </thead>
//             <tbody>
//               {loadingAdjustments ? (
//                 <tr>
//                   <td colSpan={7} className="px-4 py-10 text-center">
//                     <div className="flex items-center justify-center gap-3">
//                       <Loader2 size={20} className="animate-spin text-primary-500" />
//                       <span className="text-sm text-gray-500">Loading adjustments...</span>
//                     </div>
//                   </td>
//                 </tr>
//               ) : adjustments.length === 0 ? (
//                 <tr>
//                   <td colSpan={7} className="px-4 py-10 text-center text-sm text-gray-400">
//                     No leave adjustments recorded yet.
//                   </td>
//                 </tr>
//               ) : (
//                 adjustments.map((a, i) => (
//                   <tr key={a.id || i} className="border-b border-gray-100 last:border-0 hover:bg-gray-50 transition-colors">
//                     <td className="px-4 py-3 font-semibold text-gray-900">
//                       {a.employeeName || a.employeeId || a.serviceNo}
//                     </td>
//                     <td className="px-4 py-3 text-gray-700">{a.leaveType}</td>
//                     <td className="px-4 py-3 text-gray-700">{a.dateDisplay || formatDate(a.date)}</td>
//                     <td className="px-4 py-3 text-gray-700 tabular-nums">{a.inTime || formatTime(a.inTime)}</td>
//                     <td className="px-4 py-3 text-gray-700 tabular-nums">{a.outTime || formatTime(a.outTime)}</td>
//                     <td className="px-4 py-3 text-gray-700">{a.reason}</td>
//                     <td className="px-4 py-3">
//                       <span className="inline-flex items-center gap-1.5">
//                         <span className={`w-1.5 h-1.5 rounded-full shrink-0 ${
//                           a.status === 'A' || a.status === 'a' ? 'bg-emerald-500' :
//                           a.status === 'R' || a.status === 'r' ? 'bg-red-500' :
//                           'bg-amber-500'
//                         }`} />
//                         <span className="text-gray-600">{getStatusLabel(a.status)}</span>
//                       </span>
//                     </td>
//                   </tr>
//                 ))
//               )}
//             </tbody>
//           </table>
//           */}

//           <table className="w-full min-w-[920px] border-collapse text-[13px] table-fixed">
//             <colgroup>
//               {COLUMNS.map((c) => (
//                 <col key={c.key} style={{ width: c.width }} />
//               ))}
//             </colgroup>
//             <thead>
//               <tr className="bg-white border-b border-gray-200">
//                 {COLUMNS.map((c) => (
//                   <th
//                     key={c.key}
//                     className={`whitespace-nowrap px-4 py-3 text-[12px] font-semibold text-gray-500 ${c.headerAlign}`}
//                   >
//                     {c.label}
//                   </th>
//                 ))}
//               </tr>
//             </thead>
//             <tbody>
//               {loadingAdjustments ? (
//                 <tr>
//                   <td colSpan={COLUMNS.length} className="px-4 py-10 text-center">
//                     <div className="flex items-center justify-center gap-3">
//                       <Loader2 size={20} className="animate-spin text-primary-500" />
//                       <span className="text-sm text-gray-500">Loading adjustments...</span>
//                     </div>
//                   </td>
//                 </tr>
//               ) : adjustments.length === 0 ? (
//                 <tr>
//                   <td colSpan={COLUMNS.length} className="px-4 py-10 text-center text-sm text-gray-400">
//                     No leave adjustments recorded yet.
//                   </td>
//                 </tr>
//               ) : (
//                 adjustments.map((a, i) => (
//                   <tr key={a.id || i} className="border-b border-gray-100 last:border-0 hover:bg-gray-50 transition-colors">
//                     <td className={`px-4 py-3 font-semibold text-gray-900 truncate ${COLUMNS[0].cellAlign}`}>
//                       {a.employeeName || a.employeeId || a.serviceNo}
//                     </td>
//                     <td className={`px-4 py-3 text-gray-700 truncate ${COLUMNS[1].cellAlign}`}>{a.leaveType}</td>
//                     <td className={`px-4 py-3 text-gray-700 truncate ${COLUMNS[2].cellAlign}`}>{a.dateDisplay || formatDate(a.date)}</td>
//                     <td className={`px-4 py-3 text-gray-700 tabular-nums ${COLUMNS[3].cellAlign}`}>{a.inTime || formatTime(a.inTime)}</td>
//                     <td className={`px-4 py-3 text-gray-700 tabular-nums ${COLUMNS[4].cellAlign}`}>{a.outTime || formatTime(a.outTime)}</td>
//                     <td className={`px-4 py-3 text-gray-700 truncate ${COLUMNS[5].cellAlign}`}>{a.reason}</td>
//                     <td className={`px-4 py-3 ${COLUMNS[6].cellAlign}`}>
//                       <span className="inline-flex items-center gap-1.5">
//                         <span className={`w-1.5 h-1.5 rounded-full shrink-0 ${
//                           a.status === 'A' || a.status === 'a' ? 'bg-emerald-500' :
//                           a.status === 'R' || a.status === 'r' ? 'bg-red-500' :
//                           'bg-amber-500'
//                         }`} />
//                         <span className="text-gray-600">{getStatusLabel(a.status)}</span>
//                       </span>
//                     </td>
//                   </tr>
//                 ))
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {/* ── Add Adjustment modal ────────────────────────────────── */}
//       {modalOpen && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
//           <div className="w-full max-w-md rounded-xl bg-white p-6 shadow-lg max-h-[90vh] overflow-y-auto">
//             <div className="mb-5 flex items-center justify-between">
//               <h2 className="text-base font-semibold text-gray-900">Add Adjustment</h2>
//               <button onClick={closeModal} className="text-gray-400 hover:text-gray-600" aria-label="Close">
//                 <X size={18} />
//               </button>
//             </div>

//             <div className="space-y-4">
//               {/* Employee Search */}
//               <div>
//                 <label className={LBL}>Select Employee *</label>
//                 <EmpSearch
//                   value={form.serviceNo}
//                   onChange={onEmpSelect}
//                   employees={employeeOptions}
//                 />
//               </div>

//               {/* Leave Type */}
//               <div>
//                 <label className={LBL}>Leave Type *</label>
//                 <select
//                   className={`${SEL} ${!form.serviceNo ? 'bg-gray-100 cursor-not-allowed opacity-60' : ''}`}
//                   value={form.adjType}
//                   onChange={e => set('adjType', e.target.value)}
//                   disabled={!form.serviceNo || loadingLeaveTypes}
//                 >
//                   <option value="">Select Leave Type</option>
//                   {leaveTypes.map((type, index) => (
//                     <option
//                       key={`${type.code}-${index}`}
//                       value={type.code}
//                     >
//                       {type.label}
//                     </option>
//                   ))}
//                 </select>

//                 {leaveTypeInfo && (
//                   <div className={`mt-2 flex items-center gap-2 px-3 py-2 rounded-lg text-[11px] ${
//                     !form.serviceNo
//                       ? 'bg-blue-50 border border-blue-200 text-blue-700'
//                       : 'bg-gray-50 border border-gray-200 text-gray-600'
//                   }`}>
//                     <Info size={13} className="shrink-0" />
//                     <span>{leaveTypeInfo}</span>
//                     {loadingLeaveTypes && <Loader2 size={13} className="animate-spin ml-auto" />}
//                   </div>
//                 )}
//               </div>

//               {/* Date */}
//               <div>
//                 <label className={LBL}>Date *</label>
//                 <IsoDateInput
//                   value={form.attendanceDate}
//                   onChange={(v) => set('attendanceDate', v)}
//                   className={INP}
//                 />
//               </div>

//               {/* IN Time & OUT Time */}
//               <div className="grid grid-cols-2 gap-4">
//                 <div>
//                   <label className={LBL}>IN Time (24h) *</label>
//                   <input
//                     type="time"
//                     value={form.inTime.slice(0, 5)}
//                     onChange={(e) => set('inTime', `${e.target.value}:00`)}
//                     step="1"
//                     className={INP}
//                   />
//                 </div>
//                 <div>
//                   <label className={LBL}>OUT Time (24h) *</label>
//                   <input
//                     type="time"
//                     value={form.outTime.slice(0, 5)}
//                     onChange={(e) => set('outTime', `${e.target.value}:00`)}
//                     step="1"
//                     className={INP}
//                   />
//                 </div>
//               </div>

//               {/* Reason */}
//               <div>
//                 <label className={LBL}>Reason *</label>
//                 <input
//                   type="text"
//                   value={form.adjReason}
//                   onChange={(e) => set('adjReason', e.target.value)}
//                   placeholder="e.g. Management goodwill grant"
//                   className={INP}
//                 />
//               </div>

//               {/* Status */}
//               <div>
//                 <label className={LBL}>Status</label>
//                 <select
//                   value={form.adjStatus}
//                   onChange={(e) => set('adjStatus', e.target.value)}
//                   className={SEL}
//                 >
//                   <option value="P">Pending</option>
//                   <option value="A">Approved</option>
//                   <option value="R">Rejected</option>
//                 </select>
//               </div>
//             </div>

//             <div className="mt-6 flex justify-end gap-3">
//               <button
//                 onClick={closeModal}
//                 className="rounded-lg border border-gray-200 bg-white px-4 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleSave}
//                 disabled={!form.serviceNo || !form.adjType || !form.adjReason || loading}
//                 className="rounded-lg bg-green-600 px-4 py-2.5 text-sm font-medium text-white hover:bg-green-700 disabled:cursor-not-allowed disabled:opacity-50"
//               >
//                 {loading ? 'Adding...' : 'Add Adjustment'}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }




import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Search, X, ChevronDown, User, Loader2, Info, AlertCircle, CheckCircle, RotateCcw } from 'lucide-react';
import Table, { StatusPill, TABLE_THEME } from '../../components/Table/Table';
import EmployeeSearch from '../../components/common/EmployeeSearch';
import { fetchLeaveTypesByUser } from '../../store/slices/leaveTypesSlice';
import { fetchLeaveTypes, selectLeaveTypes } from '../../store/slices/leaveTypesSlice';
import { fetchAllEmployees } from '../../store/slices/employeeSlice';
import { addLeaveAdjustment, fetchLeaveAdjustments } from '../../store/slices/leaveAdjustmentSlice';

const INP = "w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-400 bg-gray-50 focus:bg-white transition-colors";
const SEL = INP + " appearance-none";
const LBL = "block text-[11px] font-semibold text-gray-600 mb-1 uppercase tracking-wide";

const ADJUSTMENT_TYPES = [
  { value: 'Increase', label: 'Increase' },
  { value: 'Decrease', label: 'Decrease' },
];

const ALL_EMPLOYEES = { employeeId: '__ALL__', name: 'All Employees', isAll: true };

const fmt = (v) => (!v || v === 'null') ? '' : String(v).trim();

// Current month as YYYY-MM (local time, not UTC)
const getCurrentMonth = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
};

// ─── Employee search dropdown (used inside the Add Adjustment modal) ─────────
function EmpSearch({ value, onChange, employees, placeholder = 'Search employee...' }) {
  const [q, setQ] = useState('');
  const [open, setOpen] = useState(false);
  const ref = useRef();

  const filtered = useMemo(() => {
    if (!q) return employees;
    const lq = q.toLowerCase();
    return employees.filter(e =>
      fmt(e.p_ced_service_no).toLowerCase().includes(lq) ||
      `${fmt(e.p_first_name)} ${fmt(e.p_last_name)}`.toLowerCase().includes(lq) ||
      fmt(e.p_report_name).toLowerCase().includes(lq)
    );
  }, [employees, q]);

  const selected = employees.find(e => fmt(e.p_ced_service_no) === value);
  const displayName = selected
    ? `${fmt(selected.p_ced_service_no)} — ${fmt(selected.p_report_name) || `${fmt(selected.p_first_name)} ${fmt(selected.p_last_name)}`}`
    : '';

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div ref={ref} className="relative">
      <div className={`${INP} flex items-center gap-2 cursor-pointer`} onClick={() => setOpen(v => !v)}>
        <User size={13} className="text-gray-400 shrink-0" />
        <span className={`flex-1 text-sm truncate ${value ? 'text-gray-800' : 'text-gray-400'}`}>
          {value ? displayName : placeholder}
        </span>
        <ChevronDown size={12} className={`text-gray-400 transition-transform ${open ? 'rotate-180' : ''}`} />
      </div>
      {open && (
        <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-200 rounded-xl shadow-xl z-50">
          <div className="p-2 border-b border-gray-100">
            <div className="relative">
              <Search size={12} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400" />
              <input
                autoFocus
                value={q}
                onChange={e => setQ(e.target.value)}
                placeholder="Name or service no..."
                className="w-full pl-7 pr-3 py-1.5 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-1 focus:ring-primary-300"
              />
            </div>
          </div>
          <div className="max-h-52 overflow-y-auto py-1">
            {filtered.length === 0
              ? <p className="text-center text-[12px] text-gray-400 py-3">No results</p>
              : filtered.map(e => {
                const sno = fmt(e.p_ced_service_no);
                const name = fmt(e.p_report_name) || `${fmt(e.p_first_name)} ${fmt(e.p_last_name)}`.trim();
                return (
                  <button
                    key={sno}
                    onClick={() => { onChange(sno, e); setOpen(false); setQ(''); }}
                    className={`w-full flex items-center gap-2.5 px-3 py-2 hover:bg-primary-50 transition-colors text-left ${value === sno ? 'bg-primary-50 text-primary-700' : ''}`}
                  >
                    <span className="text-[11px] font-mono text-gray-400 w-16 shrink-0">{sno}</span>
                    <span className="text-[12px] text-gray-800 truncate">{name}</span>
                  </button>
                );
              })}
          </div>
        </div>
      )}
    </div>
  );
}

// ─── Success Modal ─────────────────────────────────────────────────
function SuccessModal({ isOpen, message, onClose }) {
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 p-6">
        <div className="flex flex-col items-center text-center">
          <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mb-4">
            <CheckCircle size={32} className="text-emerald-600" />
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-2">Success!</h3>
          <p className="text-gray-600 text-sm mb-6">{message || 'Leave adjustment added successfully!'}</p>
          <button
            onClick={onClose}
            className="px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-lg transition-colors"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
}

// ─── Error Modal ─────────────────────────────────────────────────
function ErrorModal({ isOpen, message, onClose }) {
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 p-6">
        <div className="flex flex-col items-center text-center">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
            <AlertCircle size={32} className="text-red-600" />
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-2">Error</h3>
          <p className="text-gray-600 text-sm mb-6">{message || 'Failed to add leave adjustment'}</p>
          <button
            onClick={onClose}
            className="px-6 py-2.5 bg-red-500 hover:bg-red-600 text-white font-medium rounded-lg transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

// ─── Helpers ───────────────────────────────────────────────────────
function formatDate(dateStr) {
  if (!dateStr) return '';
  try {
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return dateStr;
    const p = (n) => String(n).padStart(2, '0');
    return `${date.getFullYear()}-${p(date.getMonth() + 1)}-${p(date.getDate())}`;
  } catch {
    return dateStr;
  }
}

const extractRows = (response) => {
  if (Array.isArray(response)) return response;
  if (response?.ResultSet && Array.isArray(response.ResultSet)) return response.ResultSet;
  if (response?.resultSet && Array.isArray(response.resultSet)) return response.resultSet;
  if (response?.data && Array.isArray(response.data)) return response.data;
  if (response?.data?.ResultSet && Array.isArray(response.data.ResultSet)) return response.data.ResultSet;
  return [];
};

const mapAdjustmentRows = (rows) =>
  (Array.isArray(rows) ? rows : []).map((item, idx) => ({
    id: item.HLAJ_ADJUSTMENT_ID ?? item.LeaveAdjID ?? item.HLA_ID ?? item.id ?? `${idx}-${item.HLAJ_EMP_SERVICE_NO ?? ''}`,
    empServiceNo: item.HLAJ_EMP_SERVICE_NO ?? item.EmpServiceNo ?? item.HLA_EMP_SERVICE_NO ?? item.empServiceNo ?? '',
    employeeName: item.EmployeeName ?? item.HLAJ_EMPLOYEE_NAME ?? item.HLA_EMPLOYEE_NAME ?? '',
    leaveType: item.HLAJ_LEAVE_TYPE_ID ?? item.LeaveType ?? item.HLA_LEAVE_TYPE ?? item.leaveType ?? '',
    date: item.HLAJ_ADJUSTMENT_DATE ?? item.AdjustmentDate ?? item.HLA_ADJUSTMENT_DATE ?? item.adjustmentDate ?? '',
    dateDisplay: formatDate(item.HLAJ_ADJUSTMENT_DATE ?? item.AdjustmentDate ?? item.HLA_ADJUSTMENT_DATE ?? item.adjustmentDate ?? ''),
    days: item.HLAJ_DAYS ?? item.Days ?? item.HLA_DAYS ?? item.days ?? '',
    adjustmentType: item.HLAJ_ADJUSTMENT_TYPE ?? item.AdjustmentType ?? item.HLA_ADJUSTMENT_TYPE ?? item.adjustmentType ?? '',
    reason: item.HLAJ_REASON ?? item.Reason ?? item.HLA_REASON ?? item.reason ?? '',
    approvedBy: item.HLAJ_APPROVED_BY ?? item.ApprovedBy ?? item.HLA_APPROVED_BY ?? '',
    createdBy: item.CreatedBy ?? item.HLAJ_CREATED_BY ?? '',
    createdDate: item.CreatedDate ?? item.HLAJ_CREATED_DATE ?? '',
  }));

// ═══════════════════════════════════════════════════════════════════════
//  Main page
// ═══════════════════════════════════════════════════════════════════════
export default function LeaveAdjustments() {
  const dispatch = useDispatch();

  const { employees } = useSelector(s => s.employees);
  const allLeaveTypes = useSelector(selectLeaveTypes);

  const [adjustments, setAdjustments] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingLeaveTypes, setLoadingLeaveTypes] = useState(false);
  const [loadingAdjustments, setLoadingAdjustments] = useState(false);
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [leaveTypeInfo, setLeaveTypeInfo] = useState('');

  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [modalMessage, setModalMessage] = useState('');

  // ─── Table filters (defaults: All employees, current month, all leave types)
  const [selectedEmployee, setSelectedEmployee] = useState(ALL_EMPLOYEES);
  const [monthFilter, setMonthFilter] = useState(getCurrentMonth()); // 'YYYY-MM', '' = every month
  const [leaveTypeFilter, setLeaveTypeFilter] = useState('all');      // 'all' or a leave type id

  const handleEmployeeSelect = (employee) => {
    setSelectedEmployee(employee ?? ALL_EMPLOYEES);
  };

  const resetFilters = () => {
    setSelectedEmployee(ALL_EMPLOYEES);
    setMonthFilter(getCurrentMonth());
    setLeaveTypeFilter('all');
  };

  const today = new Date().toISOString().split('T')[0];

  const [form, setForm] = useState({
    serviceNo: '',
    leaveType: '',
    adjustmentDate: today,
    days: 1,
    adjustmentType: 'Increase',
    reason: '',
  });

  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));

  useEffect(() => {
    dispatch(fetchAllEmployees());
    dispatch(fetchLeaveTypes());
  }, [dispatch]);

  const employeeOptions = useMemo(() => {
    return (employees || []).map(emp => ({
      ...emp,
      p_ced_service_no: emp.p_ced_service_no || emp.HED_SERVICE_NO || emp.HED_CED_SERVICE_NO || '',
      p_first_name: emp.p_first_name || emp.HED_FIRST_NAME || '',
      p_last_name: emp.p_last_name || emp.HED_LAST_NAME || '',
      p_report_name: emp.p_report_name || emp.HED_REPORT_NAME || '',
    })).filter(e => e.p_ced_service_no);
  }, [employees]);

  const leaveTypeNameById = useMemo(() => {
    const m = new Map();
    (allLeaveTypes || []).forEach((t) => {
      if (t?.id === undefined || t?.id === null) return;
      m.set(String(t.id), t.name || t.code || '');
    });
    return m;
  }, [allLeaveTypes]);

  const employeeNameByServiceNo = useMemo(() => {
    const m = new Map();
    employeeOptions.forEach(e => {
      m.set(
        String(e.p_ced_service_no),
        e.p_report_name || `${e.p_first_name} ${e.p_last_name}`.trim() || e.p_ced_service_no
      );
    });
    return m;
  }, [employeeOptions]);

  // Options for the shared EmployeeSearch component
  const searchOptions = useMemo(() =>
    employeeOptions.map(e => ({
      employeeId: String(e.p_ced_service_no),
      serviceNo: String(e.p_ced_service_no),
      name: e.p_report_name || `${e.p_first_name} ${e.p_last_name}`.trim() || e.p_ced_service_no,
      department: e.p_department_name || e.HDD_DEPARTMENT_NAME || '',
    })),
    [employeeOptions]);

  // Options for the Leave Type filter dropdown
  const leaveTypeFilterOptions = useMemo(() => {
    const opts = [];
    leaveTypeNameById.forEach((name, id) => opts.push({ id, name: name || `Type ${id}` }));
    // Include any leave type that appears in the records but isn't in the master list
    const known = new Set(opts.map(o => o.id));
    adjustments.forEach(a => {
      const id = String(a.leaveType ?? '');
      if (id && !known.has(id)) {
        known.add(id);
        opts.push({ id, name: `Type ${id}` });
      }
    });
    return opts.sort((a, b) => a.name.localeCompare(b.name));
  }, [leaveTypeNameById, adjustments]);

  const fetchAllAdjustments = async () => {
    if (!employeeOptions || employeeOptions.length === 0) {
      setAdjustments([]);
      return;
    }

    setLoadingAdjustments(true);
    try {
      const CONCURRENCY_LIMIT = 5; // Process 5 requests at a time
      const results = [];

      // Process employees in chunks
      for (let i = 0; i < employeeOptions.length; i += CONCURRENCY_LIMIT) {
        const chunk = employeeOptions.slice(i, i + CONCURRENCY_LIMIT);
        const chunkPromises = chunk.map((emp) =>
          dispatch(fetchLeaveAdjustments(emp.p_ced_service_no)).unwrap()
        );

        const chunkResults = await Promise.allSettled(chunkPromises);
        results.push(...chunkResults);
      }

      const merged = [];
      results.forEach((r) => {
        if (r.status !== 'fulfilled') return;
        merged.push(...mapAdjustmentRows(extractRows(r.value)));
      });

      merged.sort((a, b) => {
        const da = a.date ? new Date(a.date).getTime() : 0;
        const db = b.date ? new Date(b.date).getTime() : 0;
        return db - da;
      });

      setAdjustments(merged);
    } catch (err) {
      console.error('[COMPONENT] Error fetching all adjustments:', err);
      setAdjustments([]);
    } finally {
      setLoadingAdjustments(false);
    }
  };

  useEffect(() => {
    if (employeeOptions.length > 0) fetchAllAdjustments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employeeOptions.length]);

  // Filters apply live (no need to click Search)
  const filteredAdjustments = useMemo(() => {
    return adjustments.filter((a) => {
      if (
        selectedEmployee && !selectedEmployee.isAll &&
        String(a.empServiceNo) !== String(selectedEmployee.serviceNo)
      ) return false;

      if (monthFilter && !(a.dateDisplay || '').startsWith(monthFilter)) return false;

      if (leaveTypeFilter !== 'all' && String(a.leaveType) !== String(leaveTypeFilter)) return false;

      return true;
    });
  }, [adjustments, selectedEmployee, monthFilter, leaveTypeFilter]);

  const hasActiveFilter =
    (selectedEmployee && !selectedEmployee.isAll) || !!monthFilter || leaveTypeFilter !== 'all';

  // ─── Leave types for modal dropdown ─────────────────────────────────
  useEffect(() => {
    setLeaveTypes([]);
    setLeaveTypeInfo('');
    set('leaveType', '');

    const run = async () => {
      const serviceNo = form.serviceNo;
      if (!serviceNo) {
        setLeaveTypes([]);
        setLeaveTypeInfo('Please select an employee first to view available leave types');
        return;
      }

      setLoadingLeaveTypes(true);
      setLeaveTypeInfo('Loading leave types...');

      try {
        const result = await dispatch(fetchLeaveTypesByUser(serviceNo)).unwrap();
        const payload = result?.data ?? result;

        let leaveTypesArray = [];
        if (Array.isArray(payload)) leaveTypesArray = payload;
        else if (payload?.ResultSet && Array.isArray(payload.ResultSet)) leaveTypesArray = payload.ResultSet;
        else if (payload?.resultSet && Array.isArray(payload.resultSet)) leaveTypesArray = payload.resultSet;
        else if (payload?.data && Array.isArray(payload.data)) leaveTypesArray = payload.data;
        else if (payload && typeof payload === 'object') {
          for (const key of Object.keys(payload)) {
            if (Array.isArray(payload[key]) && payload[key].length > 0) {
              leaveTypesArray = payload[key];
              break;
            }
          }
        }

        if (leaveTypesArray.length === 0) {
          setLeaveTypes([]);
          setLeaveTypeInfo(
            (typeof result?.message === 'string' && result.message) ||
            'No leave types available for this employee'
          );
          return;
        }

        const mappedTypes = leaveTypesArray.map((item) => {
          if (typeof item === 'string' || typeof item === 'number') {
            return { code: String(item), label: String(item) };
          }

          const itemCode = String(item.HLT_CODE ?? item.HLA_LEAVE_TYPE_CODE ?? '').toUpperCase();
          const itemName = item.HLT_NAME ?? item.HLA_LEAVE_TYPE_NAME ?? '';

          let typeId = item.HLT_TYPE_ID ?? item.HLA_LEAVE_TYPE_ID ?? null;

          if (!typeId && itemCode) {
            const master = (allLeaveTypes || []).find((t) => {
              const masterCode = String(t.code ?? t.HLT_CODE ?? '').toUpperCase();
              return masterCode === itemCode;
            });
            typeId = master?.id ?? master?.HLT_TYPE_ID ?? master?.typeId ?? null;
          }

          const code = typeId != null ? String(typeId) : '';
          const label = itemName || `Leave Type ${code}`;
          return { code, label };
        });

        const validTypes = mappedTypes.filter((t) => t.code);
        if (validTypes.length > 0) {
          setLeaveTypes(validTypes);
          setLeaveTypeInfo(`${validTypes.length} leave type(s) available for this employee`);
          if (!form.leaveType) set('leaveType', validTypes[0].code);
        } else {
          setLeaveTypes([]);
          setLeaveTypeInfo('No valid leave types found for this employee');
        }
      } catch (error) {
        console.error('[LEAVE TYPES] fetch failed:', error);
        setLeaveTypes([]);
        setLeaveTypeInfo(
          (typeof error === 'string' && error) ||
          error?.message ||
          'Error loading leave types. Please try again.'
        );
      } finally {
        setLoadingLeaveTypes(false);
      }
    };

    run();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form.serviceNo]);

  const onEmpSelect = (sno) => {
    setForm(p => ({ ...p, serviceNo: sno, leaveType: '' }));
  };

  const openModal = () => setModalOpen(true);

  const closeModal = () => {
    setModalOpen(false);
    setForm({
      serviceNo: '',
      leaveType: '',
      adjustmentDate: new Date().toISOString().split('T')[0],
      days: 1,
      adjustmentType: 'Increase',
      reason: '',
    });
    setLeaveTypes([]);
    setLeaveTypeInfo('');
  };

  const handleSuccessModalClose = () => {
    setShowSuccessModal(false);
    setLoading(false);
    setForm({
      serviceNo: '',
      leaveType: '',
      adjustmentDate: new Date().toISOString().split('T')[0],
      days: 1,
      adjustmentType: 'Increase',
      reason: '',
    });
    setLeaveTypes([]);
    setLeaveTypeInfo('');
    fetchAllAdjustments();
  };

  const handleErrorModalClose = () => {
    setShowErrorModal(false);
    setLoading(false);
  };

  const handleSave = async () => {
    if (!form.serviceNo) {
      setModalMessage('Employee required');
      setShowErrorModal(true);
      return;
    }
    if (!form.leaveType) {
      setModalMessage('Leave type required');
      setShowErrorModal(true);
      return;
    }
    if (form.days === '' || form.days === null || Number(form.days) <= 0) {
      setModalMessage('Days must be greater than zero');
      setShowErrorModal(true);
      return;
    }
    if (!form.adjustmentType) {
      setModalMessage('Adjustment type required');
      setShowErrorModal(true);
      return;
    }

    setLoading(true);
    setShowSuccessModal(false);
    setShowErrorModal(false);

    const todayIso = new Date().toISOString().split('T')[0];
    const magnitude = Math.abs(Number(form.days));
    const payloadDays = form.adjustmentType === 'Decrease' ? -magnitude : magnitude;

    try {
      const result = await dispatch(addLeaveAdjustment({
        empServiceNo: form.serviceNo,
        leaveType: form.leaveType,
        adjustmentDate: todayIso,
        days: payloadDays,
        adjustmentType: form.adjustmentType,
        reason: form.reason || '',
        createdBy: form.serviceNo,
      })).unwrap();

      setLoading(false);

      if (result?.success) {
        setModalMessage(result.message || 'Leave adjustment added successfully!');
        setModalOpen(false);
        setShowSuccessModal(true);
      } else {
        setModalMessage(result?.message || 'Failed to add leave adjustment');
        setShowErrorModal(true);
      }
    } catch (e) {
      console.error('Error adding leave adjustment:', e);
      setLoading(false);
      const errorMsg = typeof e === 'string' ? e : (e?.message || 'Failed to add leave adjustment');
      setModalMessage(errorMsg);
      setShowErrorModal(true);
    }
  };

  // ─── Column definitions for the shared Table ─────────────────────────
  const columns = useMemo(() => [
    {
      key: 'employee',
      label: 'Employee',
      width: '22%',
      render: (row) =>
        employeeNameByServiceNo.get(String(row.empServiceNo))
        || row.employeeName
        || row.empServiceNo
        || '—',
      className: 'font-semibold text-gray-900 truncate',
    },
    {
      key: 'leaveType',
      label: 'Leave Type',
      width: '18%',
      render: (row) => {
        const name = leaveTypeNameById.get(String(row.leaveType));
        if (name) return name;
        return row.leaveType ? `Type ${row.leaveType}` : '—';
      },
      className: 'text-gray-700 truncate',
    },
    {
      key: 'dateDisplay',
      label: 'Date',
      width: '12%',
      render: (row) => row.dateDisplay || formatDate(row.date),
      className: 'text-gray-700',
    },
    {
      key: 'days',
      label: 'Days',
      width: '8%',
      align: 'center',
      className: 'text-gray-700 tabular-nums',
    },
    {
      key: 'adjustmentType',
      label: 'Adjustment Type',
      width: '15%',
      render: (row) => (
        <StatusPill
          label={row.adjustmentType || '—'}
          tone={row.adjustmentType === 'Decrease' ? 'danger' : 'success'}
        />
      ),
    },
    {
      key: 'reason',
      label: 'Reason',
      width: '25%',
      wrap: true,
      className: 'text-gray-600',
    },
  ], [employeeNameByServiceNo, leaveTypeNameById]);

  const fieldCls = `${TABLE_THEME.fieldBase} ${TABLE_THEME.fieldFocus}`;

  return (
    <div className="min-h-full bg-gray-50">
      <SuccessModal isOpen={showSuccessModal} message={modalMessage} onClose={handleSuccessModalClose} />
      <ErrorModal isOpen={showErrorModal} message={modalMessage} onClose={handleErrorModalClose} />

      {loading && (
        <div className="fixed inset-0 z-[90] flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-2xl shadow-2xl p-8 flex flex-col items-center">
            <Loader2 size={48} className="text-primary-500 animate-spin mb-4" />
            <p className="text-gray-700 font-medium">Adding leave adjustment...</p>
            <p className="text-gray-400 text-sm mt-1">Please wait</p>
          </div>
        </div>
      )}

      <div className="mb-6 flex items-start justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Leave Adjustments</h1>
          <p className="mt-1 text-sm text-gray-500">Manage and review employee leave adjustments.</p>
        </div>

        <button
          onClick={openModal}
          className="flex shrink-0 items-center gap-2 rounded-lg bg-primary-600 px-4 py-2.5 text-sm font-medium text-white hover:bg-primary-700"
        >
          Add Adjustment
        </button>
      </div>

      <Table
        title="Adjustment Records"
        columns={columns}
        rows={filteredAdjustments}
        rowKey="id"
        loading={loadingAdjustments}
        loadingMessage="Loading adjustments..."
        emptyMessage={
          hasActiveFilter
            ? 'No leave adjustments found for the selected filters.'
            : 'No leave adjustments recorded yet.'
        }
        pageSize={10}
        defaultSort={{ key: 'dateDisplay', dir: 'desc' }}
        className="!overflow-visible"
        toolbarExtra={
          <>
            <div className="w-[300px] max-w-full">
              <span className={TABLE_THEME.fieldLabel}>Employee</span>
              <EmployeeSearch
                value={selectedEmployee}
                onSelect={handleEmployeeSelect}
                employees={searchOptions}
                showAllOption
              />
            </div>

            <div>
              <span className={TABLE_THEME.fieldLabel}>Month</span>
              <input
                type="month"
                value={monthFilter}
                onChange={(e) => setMonthFilter(e.target.value)}
                className={fieldCls}
              />
            </div>

            <div>
              <span className={TABLE_THEME.fieldLabel}>Leave Type</span>
              <select
                value={leaveTypeFilter}
                onChange={(e) => setLeaveTypeFilter(e.target.value)}
                className={`${fieldCls} min-w-[180px]`}
              >
                <option value="all">All Leave Types</option>
                {leaveTypeFilterOptions.map((t) => (
                  <option key={t.id} value={t.id}>{t.name}</option>
                ))}
              </select>
            </div>

            <button
              type="button"
              onClick={fetchAllAdjustments}
              disabled={loadingAdjustments}
              className="flex items-center gap-2 h-9 px-4 bg-primary-600 text-white rounded-lg text-xs font-semibold hover:bg-primary-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loadingAdjustments
                ? <Loader2 size={14} className="animate-spin" />
                : <Search size={14} />}
              {loadingAdjustments ? 'Loading...' : 'Search'}
            </button>

            <button
              type="button"
              onClick={resetFilters}
              className="flex items-center gap-2 h-9 px-3 bg-gray-100 text-gray-600 rounded-lg text-xs font-semibold hover:bg-gray-200 transition-colors"
            >
              <RotateCcw size={14} />
              Reset
            </button>
          </>
        }
      />

      {/* ── Add Adjustment modal ────────────────────────────────── */}
      {modalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
          <div className="w-full max-w-md rounded-xl bg-white p-6 shadow-lg max-h-[90vh] overflow-y-auto">
            <div className="mb-5 flex items-center justify-between">
              <h2 className="text-base font-semibold text-gray-900">Add Adjustment</h2>
              <button onClick={closeModal} className="text-gray-400 hover:text-gray-600" aria-label="Close">
                <X size={18} />
              </button>
            </div>

            <div className="space-y-4">
              <div>
                <label className={LBL}>Select Employee *</label>
                <EmpSearch
                  value={form.serviceNo}
                  onChange={onEmpSelect}
                  employees={employeeOptions}
                />
              </div>

              <div>
                <label className={LBL}>Leave Type *</label>
                <select
                  className={`${SEL} ${!form.serviceNo ? 'bg-gray-100 cursor-not-allowed opacity-60' : ''}`}
                  value={form.leaveType}
                  onChange={e => set('leaveType', e.target.value)}
                  disabled={!form.serviceNo || loadingLeaveTypes}
                >
                  <option value="">Select Leave Type</option>
                  {leaveTypes.map((type, index) => (
                    <option key={`${type.code}-${index}`} value={type.code}>
                      {type.label}
                    </option>
                  ))}
                </select>

                {leaveTypeInfo && (
                  <div className={`mt-2 flex items-center gap-2 px-3 py-2 rounded-lg text-[11px] ${!form.serviceNo
                    ? 'bg-blue-50 border border-blue-200 text-blue-700'
                    : 'bg-gray-50 border border-gray-200 text-gray-600'
                    }`}>
                    <Info size={13} className="shrink-0" />
                    <span>{leaveTypeInfo}</span>
                    {loadingLeaveTypes && <Loader2 size={13} className="animate-spin ml-auto" />}
                  </div>
                )}
              </div>

              <div>
                <label className={LBL}>Days *</label>
                <input
                  type="number"
                  min="0.5"
                  step="0.5"
                  value={form.days}
                  onChange={(e) => set('days', e.target.value)}
                  className={INP}
                />
                <p className="mt-1 text-[11px] text-gray-400">
                  {form.adjustmentType === 'Decrease'
                    ? `Will be recorded as -${Math.abs(Number(form.days) || 0)} days`
                    : `Will be recorded as ${Math.abs(Number(form.days) || 0)} days`}
                </p>
              </div>

              <div>
                <label className={LBL}>Adjustment Type *</label>
                <select
                  className={SEL}
                  value={form.adjustmentType}
                  onChange={(e) => set('adjustmentType', e.target.value)}
                >
                  {ADJUSTMENT_TYPES.map((t) => (
                    <option key={t.value} value={t.value}>{t.label}</option>
                  ))}
                </select>
              </div>

              <div>
                <label className={LBL}>Reason</label>
                <input
                  type="text"
                  value={form.reason}
                  onChange={(e) => set('reason', e.target.value)}
                  placeholder=""
                  className={INP}
                />
              </div>
            </div>

            <div className="mt-6 flex justify-end gap-3">
              <button
                onClick={closeModal}
                className="rounded-lg border border-gray-200 bg-white px-4 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50"
              >
                Cancel
              </button>
              <button
                onClick={handleSave}
                disabled={!form.serviceNo || !form.leaveType || loading}
                className="rounded-lg bg-green-600 px-4 py-2.5 text-sm font-medium text-white hover:bg-green-700 disabled:cursor-not-allowed disabled:opacity-50"
              >
                {loading ? 'Adding...' : 'Add Adjustment'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}